'use client';
import { Builder } from '@builder.io/react';
// Global Product Card
import { ShippingBanner } from '../components/cart/shipping-banner';

Builder.register('insertMenu', {
  models: ['cart', 'cart-banner', 'cart-bottom'],
  name: 'Cart Components',
  items: [
    { name: 'Shipping Banner' }
  ],
  priority: 4,
});

Builder.registerComponent(ShippingBanner,
  {
    name: 'Shipping Banner',
    image: 'https://unpkg.com/browse/css.gg@2.0.0/icons/svg/format-text.svg',
    description: 'Shipping banner for Cart'
  }
);
